export function addItemById(
  id,
  quantity,
  properties = {},
  sections = 'cart-drawer',
) {
  return fetch(`${window.location.origin}/cart/add.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{ id, quantity, properties }],
      sections,
    }),
  }).then((res) => res.json())
}

export function updateItemById({
  id,
  quantity,
  properties = {},
  sections = 'cart-drawer',
}) {
  return fetch(`${window.location.origin}/cart/change.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id, quantity, properties, sections }),
  }).then((res) => res.json())
}

export function fetchCart() {
  return fetch(`${window.location.origin}/cart.js`, {
    method: 'GET',
    credentials: 'include',
  }).then((res) => res.json())
}

export function updateCart(body, sections = 'cart-drawer') {
  return fetch(`${window.location.origin}/cart/update.js`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...body, sections }),
  }).then((res) => res.json())
}
